import { getCookie } from './cookies';

interface HubspotUserIdentity {
  email: string;
}

export const identifyHubspotContact = (userData: HubspotUserIdentity) => {
  const storedUtms = sessionStorage.getItem('utm_data');
  const utmData = storedUtms ? JSON.parse(storedUtms) : {};

  const portalId = '145651354';
  const formGuid = '38bcd080-d2e0-4ebb-9708-561baba028b0';

  let hubspotCookie;

  if (window.HubSpotConversations?.getPrivacyConsentStatus) {
    const consent = window.HubSpotConversations.getPrivacyConsentStatus();
    if (consent?.categories?.analytics?.accepted === true) {
      console.log('[Consent] Analytics consent is granted. Reading HubSpot cookie.');
      hubspotCookie = getCookie('hubspotutk');
    } else {
      console.log(
        '[Consent] Analytics consent not granted. HubSpot cookie will not be read or sent.'
      );
    }
  } else {
    console.warn('[Consent] HubSpot privacy function not available. Cookie will not be sent.');
  }

  const hubspotApiUrl = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`;

  const payload = {
    fields: [
      { name: 'email', value: userData.email },
      { name: 'utm_source', value: utmData.utm_source || '' },
      { name: 'utm_medium', value: utmData.utm_medium || '' },
      { name: 'utm_campaign', value: utmData.utm_campaign || '' },
      { name: 'utm_term', value: utmData.utm_term || '' },
      { name: 'utm_content', value: utmData.utm_content || '' },
    ],
    context: {
      hutk: hubspotCookie,
      pageUri: window.location.href,
      pageName: document.title,
    },
  };

  fetch(hubspotApiUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
    .then(response => {
      if (response.ok) {
        sessionStorage.setItem('hubspot_session_updated', 'true');
        sessionStorage.removeItem('utm_data');
      } else {
        console.error('Error submitting HubSpot form:', response.statusText);
      }
    })
    .catch(error => {
      console.error('Network error while submitting HubSpot form:', error);
    });
};
